import React from 'react';
import PropTypes from 'prop-types';

import { rfcToString } from 'helpers/formatters/date_formats';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';

import SearchPage from 'components/search_page';
import SelectableRecordTable from 'components/selectable_record_table/selectable_record_table';
import SelectableRow from 'components/selectable_record_table/selectable_row';
import { DELIVERED_COLOR, OPENED_COLOR, CLICKED_COLOR } from './email_donut';

export default class EmailTable extends React.Component {
  static propTypes = {
    messages: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      sentAt: PropTypes.string.isRequired,
      subject: PropTypes.string.isRequired,
      numDelivered: PropTypes.number,
      numUniqueOpens: PropTypes.number,
      numClicks: PropTypes.number
    }))
  };

  renderColumnHeaders() {
    return (
      <React.Fragment>
        <th>Subject</th>
        <th>Sent</th>
        <th>Delivered</th>
        <th>Unique Opens</th>
        <th>Unique Clicks</th>
      </React.Fragment>
    );
  }

  render() {
    return (
      <div className="table-container">
        <SearchPage>
          <SelectableRecordTable
            className="mt-4"
            columnHeaders={this.renderColumnHeaders()}
            hasSelectAll={false}
            hasSelectColumn={false}
          >
            {this.props.messages.map(message => (
              <SelectableRow className="message-row" hideCheckbox key={message.id}>
                <td>
                  {message.subject}
                  <p className="visible-xs mb-0 mt-1">
                    {rfcToString(message.sentAt)}
                    <br />
                    <FontAwesomeIcon className="mr-2" color={DELIVERED_COLOR} icon={faCircle} />
                    {message.numDelivered}
                    <FontAwesomeIcon className="ml-3 mr-2" color={OPENED_COLOR} icon={faCircle} />
                    {message.numUniqueOpens}
                    <FontAwesomeIcon className="ml-3 mr-2" color={CLICKED_COLOR} icon={faCircle} />
                    {message.numClicks}
                  </p>
                </td>
                <td className="hidden-xs">{rfcToString(message.sentAt)}</td>
                <td className="hidden-xs">{message.numDelivered}</td>
                <td className="hidden-xs">{message.numUniqueOpens}</td>
                <td className="hidden-xs">{message.numClicks}</td>
              </SelectableRow>
            ))}
          </SelectableRecordTable>
        </SearchPage>
      </div>
    );
  }
}
